import { Map } from 'immutable';
import { createAction, handleActions } from 'redux-actions';
export const actions = {
    REQUEST: createAction('ACCOUNTS/PHONE_COUNTRY/REQUEST'),
    COUNTRIES_SUCCESS: createAction('ACCOUNTS/PHONE_COUNTRY/COUNTRIES_SUCCESS'),
    COUNTRIES_EU_SUCCESS: createAction('ACCOUNTS/PHONE_COUNTRY/COUNTRIES_EU_SUCCESS'),
    ERROR: createAction('ACCOUNTS/PHONE_COUNTRY/ERROR'),
};
export const initialState = Map({
    countriesList: null,
    countriesListEU: null,
    isProcessing: false,
    error: null,
    loaded: false,
});
const reducer = handleActions({
    [actions.REQUEST]: (state) => state.merge({ isProcessing: true, error: false, loaded: false }),
    [actions.COUNTRIES_SUCCESS]: (state, action) => state.merge({
        isProcessing: false,
        error: false,
        countriesList: action.payload,
        loaded: true,
    }),
    [actions.COUNTRIES_EU_SUCCESS]: (state, action) => state.merge({
        isProcessing: false,
        error: false,
        countriesListEU: action.payload,
        loaded: true,
    }),
    [actions.ERROR]: (state) => state.merge({ isProcessing: false, error: true, loaded: false }),
}, initialState);
export default reducer;
